import { routerReducer } from '@ngrx/router-store';
import { ActionReducer, ActionReducerMap, MetaReducer, INIT, UPDATE } from '@ngrx/store';
import { AppState } from '../states';
import { authenticationReducer } from './authentication.reducer';
import { dataProcessingReducer } from './pds/dataprocessing.reducer';
import { dataVisualizationReducer } from './pds/datavisualization/datavisualization.reducer';
import { queuesReducer } from './queues.reducer';
import { generalReducer } from './general.reducer';

export const reducers: ActionReducerMap<AppState> = {
  authentication: authenticationReducer,
  router: routerReducer,
  dataprocessing: dataProcessingReducer,
  datavisualization: dataVisualizationReducer,
  queues: queuesReducer,
  general: generalReducer,
};

export function storageMetaReducer(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return function (state, action) {
    if (action.type === INIT || action.type === UPDATE) {
      const storageValue = localStorage.getItem('__paques_root__');
      
      if (storageValue) {
        try {
          return JSON.parse(storageValue);
        } catch {
          localStorage.removeItem('__paques_root__');
        }
      }
    }

    const nextState = reducer(state, action);
    const { datavisualization, ...newNextState } = nextState;
    
    localStorage.setItem('__paques_root__', JSON.stringify(newNextState));

    return nextState;
  };
}

export const metaReducers: MetaReducer<AppState>[] = [storageMetaReducer];
